import { Component } from '@angular/core';

@Component({
  selector: 'app-institut-wissen',
  templateUrl: './institut-wissen.component.html',
  styleUrl: './institut-wissen.component.scss',
  standalone: false,
})
export class InstitutWissenComponent {
  public isLoading = false;
}
